import { Vue, Component, Prop } from 'vue-property-decorator';
import { IModalComponent, Btn, Field, DropdownField, FormButtonDisabler, TextareaField } from '@samc/centricity-core';
import { IMergePackageRequest } from '@/Interfaces';

// Declare the component needed to be used for this html
@Component({
  name: 'select-merge-survivor-modal',
  components: { DropdownField, Btn, Field, FormButtonDisabler, TextareaField }
})
export default class SelectMergeSurvivorModal extends Vue implements IModalComponent {
  @Prop() public addCloseProp!: (callback: () => Promise<any>) => void;
  @Prop() public closeProp!: () => void;

  @Prop({ required: true }) public selectedPkgs!: any[];
  @Prop({ required: true }) public mergeType!: string;

  public mergeTarget = '';
  public description: string = '';
  
  public get mergeDropdownField(): string {
    return this.mergeType == 'package' ? 'packageName' : 'dealName';
  }
  public get mergeLabelName(): string {
    return this.mergeType == 'package' ? 'Package Name' : 'Deal Name';
  }

  public mounted() {

    this.addCloseProp(async () => {
      const messages: string[] = [];
      if (this.mergeTarget.length === 0) messages.push('Please select a ' + this.mergeType == 'package' ? 'Package' :'Deal' +'  Name.');
      if (this.description === undefined || this.description?.length === 0) messages.push('Please include a reason for merge');

      if (messages.length === 0) {
        return {
          targetPackageGuid: this.mergeTarget,
          description: this.description
        } as IMergePackageRequest;
      }

      this.$alert({
        title: 'Validation Errors Occurred',
        description: 'Please read below for details',
        type: 'error',
        errors: messages.slice(0, 10)
      });
    });
  }
}